function ClientVersionsCtrl($scope, $filter, UploadFileService, GeneralUtilsService){

    $scope.selectedVersions=[];

    var changedItems;

    /*
     * setting the types of clients defined
     * statically each one mapped to its own version list
    */
    $scope.clients = {
        android: {
            key:'Android',
            type: 'ANDROID',
            name: 'Android',
            file_required: false
        },
        mac: {
            key:'Mac',
            type: 'MAC',
            name: 'Mac',
            file_required: false
        },
        ios: {
            key:'IOS',
            type: 'IOS',
            name: 'Ios',
            file_required: false
        },
        linux: {
            key:'Linux',
            type: 'LINUX',
            name: 'Linux',
            file_required: true
        },
        linux_fedora: {
            key:'LinuxFedora',
            type: 'LINUX_FEDORA',
            name: 'Linux Fedora',
            file_required: true
        },
        linux_centos: {
            key:'LinuxCentos',
            type: 'LINUX_CENTOS',
            name: 'Linux CentOS',
            file_required: true
        }

        ,
        linux_debian_9_0: {
            key:'LinuxDebian90',
            type: 'LINUX_DEBIAN_9_0',
            name: 'Linux Debian 9.0',
            file_required: true
        },
        linux_ubuntu_14: {
            key:'LinuxUbuntu14',
            type: 'LINUX_UBUNTU_14',
            name: 'Linux Ubuntu 14',
            file_required: true
        },
        linux_ubuntu_16: {
            key:'LinuxUbuntu16',
            type: 'LINUX_UBUNTU_16',
            name: 'Linux Ubuntu 16',
            file_required: true
        },
        windows: {
            key:'Windows',
            type: 'WINDOWS',
            name: 'Windows',
            file_required: true
        },
        all: {
            name: 'all'
        }
    };


    // holding all clients loaded from server
    var allClients ;


    /**
     * method for removing from source array all elements
     * found on elements2Remove
     * @param source
     * @param elements2Remove
     */
    var removeItems = function (source,elements2Remove) {
        elements2Remove.forEach(function (element) {
            var index = source.indexOf(element);
            if (index > -1) {
                source.splice(index, 1);
            }
        });
    };

    //default set to show all clients
    $scope.state = $scope.clients.all;

    /**
     * creates an array of all items needed to be removed from the array
     * by the type found on the state
     * @param items
     * @returns {Array}
     */
    function getItems2RemoveByType(items) {
        var toRemove = [];
        items.forEach(function (item) {
                if ($scope.state.type && item.clientType != $scope.state.type) {
                    toRemove.push(item);
                }
            }
        );
        return toRemove;
    }

    function initTable() {
        var tableFields = [{"label": "Version", "path":"version", "template":"<span>{{item.version}}</span>"}];
        tableFields.push(
            {"label": "Production", "path":"production", "template":"<div class='checkbox form-checkbox'><label><input type='checkbox' ng-model='item.production'></label></div>"},
            {"label": "Supported", "path":"supported", "template":"<div class='checkbox form-checkbox'><label><input type='checkbox' ng-model='item.supported'></label></div>"},
            {"label": "EOL", "path": "EOL", "template": "<div class='checkbox form-checkbox'><label><input type='checkbox' ng-model='item.EOL'></label></div>"},
            {"label": "EA", "path":"EA", "template":"<div class='checkbox form-checkbox'><label><input type='checkbox' ng-model='item.EA'></label></div>"},
            {"label": "Release  Notes", "path": "releaseNotes", "template": "<textarea ng-model='item.releaseNotes'></textarea>"},
            {"label": "Comment", "path": "comment", "template": "<textarea ng-model='item.comment'></textarea>"},
            {"label": "Files", "path": "fileName", "template": "<label ng-repeat='file in item.clientFiles'> {{file}}</label>"},
            {"label": "Type", "path": "clientType", "template": "<span>{{item.clientType}}</span>"}
            );


        $scope.tableConfig = {
            id: $scope.state.name,
            dataURL : function() {
                return '/clients';
            },
            processData: function(items){
                allClients =_.cloneDeep(items);
                var toRemove = getItems2RemoveByType(items);
                removeItems(items,toRemove);
                return items;
            },
            fields : tableFields,
            type : "ClientVersion",
            pageSize: 20,
            addAction: function(){
                $scope.newVersion = {id:GeneralUtilsService.getRandomId(), "name": ""};
                $scope.$root.openPopup('addVersionDlg');
            },
            actions: ["remove"],
            editTable: true,
            titleSearch: "Versions",
            sortField: "version",
            sortDir: "DESC",
            hasChanges: function(){
                return $scope.$root.hasChanges();
            }
        };
    }

    initTable($scope.state);

    /**
     * setting watch on the stat chosen by the user
     * each change will cause
     */
    $scope.$watch("state", function(newVal, oldVal){
        if (newVal !== oldVal) {
            $scope.newVersion = {};
            loadLocalClientVersions();

            if($scope.tableConfig.items){
                // empty the current array
                for(var ind=$scope.tableConfig.items.length-1;ind >=0;ind--){
                    $scope.tableConfig.items.pop();
                }
            }
            // clearing selected items
            if($scope.tableConfig.selectedItems){
                $scope.tableConfig.selectedItems=[];
            }
            allClients.forEach(function (item) {
                if ($scope.state.type && item.clientType == $scope.state.type) {
                    // copy the element since we don't want changes on it to reflect to the original source
                    $scope.tableConfig.items.push(angular.copy(item));
                }
            });
        }
    });


    /**
     * load the client version for a specific client type
     */
    function loadLocalClientVersions(force) {
        if(!$scope.state.clientVersions || force){
            store.fetch({
                path: "/clientVersions",
                method: 'POST',
                queryParams: {'limit':40,os: $scope.state.type},
                success: function(data) {
                    $scope.state.clientVersions = data;
                    $scope.localClientVersions = $scope.state.clientVersions;
                }
            });
        }
        else{
            $scope.localClientVersions = $scope.state.clientVersions;
        }
    }


    /**
     * check if element found on the sources elements
     * @param sources
     * @param element
     * @returns {boolean}
     */
    var isFound = function (sources, element) {
        var found = false;

        sources.forEach(function (sourceElement) {
            found = found || angular.equals(sourceElement,element);
        });
        return found;
    };


    /**
     * setting the has changed function to the custom has changed suited to
     * the table holding the clients
     */
    function init(){
        $scope.$root.hasChanges = function(){
            if(allClients && $scope.tableConfig && $scope.tableConfig.items) {
                changedItems =[];
                var hasChanged = false;
                $scope.tableConfig.items.forEach(function (tableItem) {
                    if (!isFound(allClients,tableItem)) {
                        changedItems.push(tableItem);
                        hasChanged = true;
                    }
                });

                hasChanged = hasChanged || (!hasChanged && $scope.state == $scope.clients.all && $scope.tableConfig.items.length != allClients.length);

                return hasChanged;
            };
        };
    };

    init();


    /**
     * used to save the changes on client versions
     */
    $scope.saveChanges = function(){
        var params = {'type': 'ClientVersion'};
        store.save({
            path: "/saveClientVersions",
            data: changedItems,
            dataObj: 'json',
            queryParams: params,
            success: function(data){
                $scope.$root.handleServerResponse(data, "" , 'Versions changes were saved successfully');
                if(data.data && data.data.items){
                    $scope.datamodified = new Date().getTime();
                }
            }
        });
    };

    /**
     * check if the input received is in length less then 10 characters
     * and that each character is a digit
     * @param input
     * @returns {*|boolean}
     */
    function numberValidation(input) {
        var pattern = /^[0-9][0-9|.]{0,10}$/;
        return input && pattern.test($scope.newVersion.version);
    }


    /**
     * check if the new version is valid if not adding error
     * if valid existing errors will be deleted
     */
    $scope.validateVersion = function () {
        var isValid = numberValidation($scope.newVersion.version);
        if(!isValid){
            $scope.$root.errors['version.versionError'] = 'Version must be constructed using digits only(maximum 10 characters)';
        }
        else{
            delete $scope.$root.errors['version.versionError'];
        }
    };


    function getVersionNumber(versionStr) {
        var res = "";
        var versionTokens = versionStr.split(".");
        for(let ind=0 ; ind<versionTokens.length-1;ind++){
            res= res +"." + versionTokens[ind];
        }
        return res.slice(1,res.length);
    }

    /**
     * adding a version to the server ( new one )
     */
    $scope.addVersion = function(){
        var params = {'type': 'ClientVersion', 'save': true};
        $scope.newVersion.name = $scope.newVersion.version ;
        $scope.newVersion.clientType = $scope.state.type;
        // $scope.newVersion.fileName = $scope.selectedVersions[0];
        $scope.newVersion.clientFiles = $scope.selectedVersions;

        store.save({
            path: "/add",
            data: $scope.newVersion,
            dataObj: 'json',
            queryParams: params,
            success: function(data) {
                $scope.$root.handleServerResponse(data, "version", "Clients version added successfully");
                if(data.status !== "ERROR"){
                    $scope.selectedVersions.splice(0, $scope.selectedVersions.length);
                    $scope.tableConfig.selectedId = data.model.id;
                    $scope.datamodified = new Date().getTime();
                    $scope.$root.closePopup('addVersionDlg');
                }
            }
        });
    };

    /**
     * closing add version dialog and reinitialize the
     * newVersion
     */
    $scope.closeAddVersionDlg = function () {
        $scope.newVersion = {};
        $scope.$root.closePopup('addVersionDlg');
    };

    $scope.uploading=false;


    /**
     * method for stating ig the upload file button should be disabled
     * @returns {boolean}
     */
    $scope.isUploadFileDisabled = function () {
        return document.getElementById('fileUploadInput').value == "" || document.getElementById('fileUploadInput').value == null;
    };

    $scope.uploadFile = function () {
        $scope.uploadButtonText = "Uploading...";
        // avoid multi upload requests
        if(!$scope.uploading){
            var uploadUrl = "/uploadClientVersionFile";
            UploadFileService.uploadFileToUrl($scope.uploadedClientVersion,uploadUrl,$scope.state.type,onUploadSuccess,onUploadError,onUploadProgress);
            $scope.uploading = true;
        }
    };


    var uploadButtonCssArgs ={
        start: {
            R: 239,
            G: 239,
            B: 239
        },
        end : {
            R: 143,
            G: 203,
            B: 0
        }
    };

    $scope.uploadButtonText = "Upload Me";

    function onUploadProgress(evt) {
        var percentComplete = ((evt.loaded / evt.total));
        var R = Math.ceil(((uploadButtonCssArgs.end.R - uploadButtonCssArgs.start.R) * percentComplete)+ uploadButtonCssArgs.start.R);
        var G = Math.ceil(((uploadButtonCssArgs.end.G - uploadButtonCssArgs.start.G) * percentComplete)+ uploadButtonCssArgs.start.G);
        var B = Math.ceil(((uploadButtonCssArgs.end.B - uploadButtonCssArgs.start.B) * percentComplete)+ uploadButtonCssArgs.start.B);
        document.getElementById('fileUploadButton').style.background = 'rgb('+R+','+G+','+B+')';
        $scope.uploadButtonText ="Uploading..."+" ("+Math.ceil(percentComplete*100) +"%)";
    }
    
    function onUploadSuccess() {
        document.getElementById('fileUploadButton').style.background = null;
        document.getElementById('fileUploadInput').value = null;
        $scope.uploadButtonText = "Upload Me";
        $scope.uploading=false;
        loadLocalClientVersions(true);
    };

    function onUploadError() {
        document.getElementById('fileUploadButton').style.background = null;
        $scope.uploading=false;
        $scope.uploadButtonText = "Upload Me";
    };

}